import React, { useState } from "react";
import {
  Button, DropdownToggle, DropdownMenu, Card, Label, CardBody, Dropdown, DropdownItem
} from "reactstrap";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import IntlMessages from "../../helpers/IntlMessages";
import defaultValues from "../../constants/defaultValues";
import { addBookingItem } from "../../redux/booking/actions";
import KeylessContainer from "./KeylessContainer";
import LoyaltyAndGuestPreferences from "./LoyaltyAndGuestPreferences";
import MolainnKeylessAccessContainer from "./MolainnKeylessAccessContainer";

const BookingLeftSideSection = ({ booking, match, addBookingItem, hotelConfig, addBookingLoading }) => {
  const [dropdownBasicOpen, setDropdownBasicOpen] = useState(false);

  const toggleBasic = () => setDropdownBasicOpen(!dropdownBasicOpen);

  const handleBookingStatus = (sender) => {
    const status = sender.currentTarget.value;
    const bookingId = match.params.id;

    const toPatch = { status, id: bookingId };
    addBookingItem(toPatch);
  };

  const getOtherBookingStatusesForDropdownItems = () => {
    const { bookingStatusEnum } = defaultValues;

    return Object.keys(bookingStatusEnum)
      .filter(bookingStatus => {
        if (bookingStatus === booking.status) return false;
        return true;
      })
      .map(bookingStatus => (
        <DropdownItem onClick={handleBookingStatus} key={`${bookingStatus}`} value={`${bookingStatus}`}>
          <IntlMessages id={`${bookingStatusEnum[bookingStatus]}`} />
        </DropdownItem>
      ));
  }

  const getBookingStatusColor = () => {
    const { status } = booking;
    switch (status) {
      case "hotel_guest":
        return "success";
      case "awaiting_approval":
        return "warning";
      case "invalid_booking":
        return "danger";
      case "checked_out":
        return "gray";

      default:
        return "info";
    }
  }

  const handleRoomsWithCheckBookingPms = () => {
    const toPatch = { check_with_pms: true, id: match.params.id };
    addBookingItem(toPatch);
  };

  // Burayı satırı hiçbir şekilde silme
  if (!booking) return (<>Booking Not Found</>);

  return (
    <>
      <Card className="text-center" style={{ overflow: "hidden" }}>
        <CardBody>
          <h3 className="list-item-heading mb-2">{booking.fullName}</h3>

          <div className="mb-5 text-center" style={{ paddingBottom: "15px" }}>
            {booking.phone_number && (
              <div className="text-center">
                <a href={`tel:${booking.phone_number}`} style={{ color: "green" }}>
                  <i className="simple-icon-phone" />
                  {booking.phone_number}
                </a>
              </div>
            )}
          </div>
        </CardBody>
      </Card>

      <div style={{ marginTop: "-50px" }}>
        <Dropdown isOpen={dropdownBasicOpen} toggle={toggleBasic} className="text-center w-100">
          <DropdownToggle caret color={`${getBookingStatusColor()}`}>
            <IntlMessages id={`bookingDetails.${booking.status}`} />
          </DropdownToggle>

          <DropdownMenu>{getOtherBookingStatusesForDropdownItems()}</DropdownMenu>
        </Dropdown>
      </div>

      <KeylessContainer
        booking={booking}
        match={match}
      />

      <LoyaltyAndGuestPreferences
        booking={booking}
      />

      <MolainnKeylessAccessContainer
        booking={booking}
        match={match}
      />

      {!addBookingLoading ?
        (
          <Card className="mb-4 mt-4">
            <CardBody>
              {hotelConfig.repeatCheckPms && hotelConfig.repeatCheckPms === true && (
                <div>
                  <div className="text-muted float-left w-50 mb-1 mt-2">
                    <IntlMessages id="bookingDetails.check_with_pms" />
                  </div>

                  <div className="w-50 float-right mb-1">
                    <Button color="primary" size="xs" onClick={handleRoomsWithCheckBookingPms}>
                      <IntlMessages id="bookingDetails.check_with_pms" />
                    </Button>
                  </div>
                </div>
              )}

              <Label className="mb-2 float-left w-100">
                <Label className="text-muted mb-2 mt-3">
                  <IntlMessages id="bookingDetails.created_at" />
                </Label>{" "}
                {booking.created_at_date ? booking.created_at_date : "-"}
                <br />
              </Label>

              <Label className="mb-2 float-left w-100">
                <Label className="text-muted mb-2">
                  <IntlMessages id="bookingDetails.last_update" />
                </Label>{" "}
                {booking.updated_at_date ? booking.updated_at_date : "-"} <br />
              </Label>
            </CardBody>
          </Card>
        ) : (
          <Card className="mb-4 text-center">
            <CardBody>
              <div className="loading" style={{ position: "inherit" }} />
            </CardBody>
          </Card>
        )
      }
    </>
  );
};

const mapStateToProps = ({ bookingApp, settings }) => {
  const { hotelConfig } = settings;
  const { addBookingLoading } = bookingApp;
  return { hotelConfig, addBookingLoading };
}

const mapActionsToProps = {
  addBookingItem
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(BookingLeftSideSection)
);
